import { ReactNode } from 'react'

import { Td, TdProps } from 'app/common/ui-components/table'

export type CommonRenderCellProps<
  T extends Record<string, unknown>,
  K extends keyof T = keyof T,
> = {
  columnKey: K
  cellData: T[K]
  rowIndex: number
  colIndex: number
  rowData: T
  cellProps?: Partial<TdProps>
}

export type CommonRenderCell<T extends Record<string, unknown>, K extends keyof T> = (
  props: CommonRenderCellProps<T, K>,
) => ReactNode

export const defaultRenderCell = <T extends Record<string, unknown>, K extends keyof T>({
  columnKey,
  cellData,
  rowIndex,
  colIndex,
  rowData,
  cellProps,
}: CommonRenderCellProps<T, K>) => {
  return <Td {...cellProps}>{cellData as ReactNode}</Td>
}
